/**
 * @author       yontaek@zumper.com (Yon Taek Chung)
 * @copyright    Copyright (c) 2022, Zumper
 */

// param keys
export const ALL_AMENITIES = 'allAmenities'
export const FINAL_AMENITIES = 'finalAmenities'
export const REQUIRED_AMENITIES = 'requiredAmenities'
export const NEIGHBORHOOD = 'neighborhood'
export const PETS = 'pets'

export const SEARCH_PREFERENCES = 'searchPreferences'

// section title
export const AMENITIES = 'Amenities'

// amenity keys for parking and laundry
export const GARAGE_PARKING_KEY = 'b-8'
export const ASSIGNED_PARKING_KEY = 'l-5'
export const BUILDING_LAUNDRY_KEY = 'b-4'
export const IN_UNIT_LAUNDRY_KEY = 'l-16'
export const LISTING_LAUNDRY_KEY = 'l-1'

// amenity keys for ordering
export const AIR_CONDITION_KEY = 'l-2'
export const BALCONY_KEY = 'l-8'
export const DISHWASHER_KEY = 'l-7'
export const FURNISHED_KEY = 'l-13'
export const POOL_KEY = 'b-9'
export const CENTRAL_HEAT_KEY = 'l-14'
export const HARDWOOD_FLOOR_KEY = 'l-11'
export const GYM_KEY = 'b-3'
export const OUTDOOR_SPACE_KEY = 'b-14'

export const AMENITIES_LAUNDRY_KEYS = [
  IN_UNIT_LAUNDRY_KEY,
  BUILDING_LAUNDRY_KEY,
  LISTING_LAUNDRY_KEY,
]

export const AMENITIES_PARKING_KEYS = [ASSIGNED_PARKING_KEY, GARAGE_PARKING_KEY]

export const AMENITIES_PARAM_KEYS = [
  FINAL_AMENITIES,
  REQUIRED_AMENITIES,
  NEIGHBORHOOD,
  PETS,
  SEARCH_PREFERENCES,
]

// need to exclude landing view
export const AMENITIES_NUM_VIEWS = 5 // AMENITIES_VIEWS.length
